var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('AudioIcon'),_c('div',{staticClass:"text-container-l5-s4"},[_c('p',[_vm._v(_vm._s(_vm.text[0])),_c('span',{on:{"click":_vm.onForward}},[_vm._v(_vm._s(_vm.text[1]))]),_vm._v(_vm._s(_vm.text[2]))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }